export const UI_VERSION = 'v7.21.0'
export const SYSTEM_VERSION = 'v8.13.7'
// export const SYSTEM_VERSION = 'v7.0.0'
// export const UI_VERSION = 'v7.2.2's